<div #notificationDiv *ngIf="message">
    <div *ngIf="inprogressMsg === 'completed'" class="uploadStatusDisplay">
        <span class="label-tmna ms-2">{{message}}</span>
    </div>
    <div *ngIf="inprogressMsg === 'failure'" class="uploadFailureStatusDisplay">
        <span class="label-tmna ms-2">{{message}}</span>
    </div>
</div>